export const visit = (vm, at) => {
vm(require("foundations-components/lang/tl.lyaml"));
at({ "tl": { "placeholder": "placeholder" } });
};